module.exports = __webpack_public_path__ + "img/10-1.242b59ba.png";